let scheduled = false;

export function scheduleScrollToFirstError() {
    if (scheduled) {
        return;
    }

    scheduled = true;

    requestAnimationFrame(() => {
        scheduled = false;

        const firstError = document.querySelector('[data-scroll-to-error]');

        firstError?.scrollIntoView({behavior: 'smooth', block: 'center'});
    });
}
